import { Image, Modal, UnstyledButton } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import React from "react";
import "../../../(dashboards)/component/DetailUser.css";
import "./ShowCard.css";

interface showpictrue {
  url?: string;
  data?: any;
}

export default function ShowCard({ url, data }: showpictrue) {
  const [opened, { open, close }] = useDisclosure(false);
  return (
    <>
      <Modal
        opened={opened}
        onClose={close}
        title="ข้อมูลบัณฑิต"
        size="md"
        centered
        classNames={{ title: "admin-modal-title" }}
      >
        <div className="DetailUser admin-detail-user">
          <div className="DetailUser-Image">
            <Image src={`${data?.picture}`} w={120} radius="md" />
          </div>
          <div className="DetailUser-Title">
            <div className="DetailUser-row">
              <div className="DetailUser-Title-Bg">บัณฑิตลำดับที่</div>
              <div className="DetailUser-value">{data?.number_true}</div>
            </div>
            <div className="DetailUser-row">
              <div className="DetailUser-Title-Bg">รหัสประจำตัว</div>
              <div className="DetailUser-value">{data?.stdid}</div>
            </div>
            <div className="DetailUser-row">
              <div className="DetailUser-Title-Bg">ชื่อ - นามสกุล</div>
              <div className="DetailUser-value">
                {data?.name} {data?.lname}
              </div>
            </div>
            <div className="DetailUser-row">
              <div className="DetailUser-Title-Bg">สังกัด</div>
              <div className="DetailUser-value">
                {data?.levelk} สาขาวิชา{data?.programe}
              </div>
            </div>
            <div className="DetailUser-row">
              <div className="DetailUser-Title-Bg">ระดับการศึกษา</div>
              <div className="DetailUser-value">{data?.vut}</div>
            </div>
          </div>
        </div>
      </Modal>
      <UnstyledButton onClick={open} className="admin-showcard-thumb">
        <Image radius="md" src={`${url}`} w={48} h={48} fit="cover" />
      </UnstyledButton>
    </>
  );
}
